import React from "react";
import { Route } from "react-router-dom";

export default ({ path, ...rest }) => {
  return <Route {...rest} />;
};
